import React from "react";
import { SVG } from "@components/items/common/SVG";
import TranslatedTextTemp from "@components/items/display/TranslatedTextTemp";
import { getQueryFromUrl } from "@utils/helpers/getQueryFromUrl";

interface Tab {
  id: string;
  title: string;
  path: string;
  onClick: () => void;
  iconPath?: string;
  activeIconPath?: string;
}

const B2BSideBar = ({
  Logo,
  tabs = [],
  isB2B,
}: {
  Logo?: React.ReactNode;
  tabs: Tab[];
  isB2B?: boolean;
}) => {
  const activeTab = getQueryFromUrl("tabId");

  return (
    <nav className="flex h-full flex-col items-center justify-center p-5">
      <div className="grid items-center justify-center gap-y-12">
        <div>{Logo}</div>
        {tabs?.map(
          ({ id, title, path, iconPath, activeIconPath, onClick }, index) => {
            const isSelected = activeTab === id;

            return (
              <div
                key={index}
                className={`flex cursor-pointer flex-col items-center justify-center text-[#B0B1B3] hover:opacity-80 ${
                  isSelected && (isB2B ? "text-b2b-primary" : "text-primary")
                }`}
                onClick={onClick}
              >
                <SVG
                  src={
                    isSelected && activeIconPath
                      ? activeIconPath
                      : iconPath || ""
                  }
                  preProcessor={(code: string) =>
                    code
                      .replace(
                        /(fill=)"(?!none")[^"]+"/g,
                        `fill="currentColor"`
                      )
                      .replace(
                        /(stroke=)"(?!none")[^"]+"/g,
                        `stroke="currentColor"`
                      )
                  }
                />
                <div
                  className={`mt-1 text-[14px] font-bold ${
                    isSelected && (isB2B ? "text-b2b-primary" : "text-primary")
                  }`}
                >
                  {title}
                </div>
              </div>
            );
          }
        )}
      </div>

      <div className="mt-auto space-y-8">
        {/* <div className="flex cursor-pointer flex-col items-center justify-center space-y-1 text-[#B0B1B3] transition-colors duration-300 hover:text-navy-blue">
          <SVG
            src="/assets/b2b/download-app.svg"
            width={44}
            height={30}
            preProcessor={(code: string) =>
              code
                .replace(/(fill=)"(?!none")[^"]+"/g, 'fill="currentColor"')
                .replace(/(stroke=)"(?!none")[^"]+"/g, 'stroke="currentColor"')
            }
          />
          <TranslatedTextTemp
            origintext="Install App"
            text={`tabs.${"install-app"}`}
            className="text-[14px]"
          />
        </div> */}

        <div className="flex items-center justify-between gap-x-10">
          <SVG
            src="/assets/b2b/icons/settings.svg"
            width={44}
            height={30}
            preProcessor={(code: string) =>
              code
                .replace(/(fill=)"(?!none")[^"]+"/g, 'fill="currentColor"')
                .replace(/(stroke=)"(?!none")[^"]+"/g, 'stroke="currentColor"')
            }
            className="cursor-pointer text-[#B0B1B3] transition-colors duration-300 hover:text-navy-blue"
            onClick={() => {
              // setActiveTab?.('settings');
              // router.push('/b2c/settings');
            }}
          />
          <SVG
            src="/assets/b2b/icons/help.svg"
            width={44}
            height={30}
            preProcessor={(code: string) =>
              code
                .replace(/(fill=)"(?!none")[^"]+"/g, 'fill="currentColor"')
                .replace(/(stroke=)"(?!none")[^"]+"/g, 'stroke="currentColor"')
            }
            className="cursor-pointer text-[#B0B1B3] transition-colors duration-300 hover:text-navy-blue"
            onClick={() => {
              // setActiveTab?.('help');
              // router.push('/b2c/help');
            }}
          />
        </div>
      </div>
    </nav>
  );
};

export default B2BSideBar;
